<!-- Affichage du tableau lorsque les données sont chargées -->
@if (!!filteredDocuments) {
    <table class="details-table" matSort (matSortChange)="sort($event)" [matSortActive]="currentSort.active" [matSortDirection]="currentSort.direction">
        <thead>
            <tr>
                @for (column of displayedColumnsDefinitions; track column.propertyCode) {
                    <th [style.width.px]="column.size" [style.max-width.px]="column.size" [class]="column.propertyCode">
                        <app-detail-table-header-cell
                            [filterHandler]="tableHeaderFilterHandler"
                            [column]="column"
                            [detailTableDataType]="DetailTableDataType.History"></app-detail-table-header-cell>
                    </th>
                }
            </tr>
        </thead>
        <tbody>
            <!-- Affichage lorsque le tableau est vide -->
            @if (filteredDocuments.length === 0) {
                <tr>
                    <td>Pas de données...</td>
                </tr>
            }
            <!-- Affichage lorsque le tableau est rempli -->
            @for (data of filteredDocuments; track data.id) {
                <tr
                    [ngClass]="{
                        'is-selected-tr': selectedHistory === data.id,
                        error: data.severityLevel === SeverityLevel.Error,
                        warning: data.severityLevel === SeverityLevel.Warning,
                    }"
                    (click)="onHistorySelected(data)">
                    @for (column of displayedColumnsDefinitions; track column.propertyCode) {
                        <td
                            class="detail-td"
                            [ngClass]="{ 'cell-icon': column.type === PropertyType.Enum }"
                            [style.width.px]="column.size"
                            [style.max-width.px]="column.size"
                            [class]="column.propertyCode">
                            <app-history-table-cell [column]="column" [data]="data"></app-history-table-cell>
                        </td>
                    }
                </tr>
            }
        </tbody>
        <ngx-spinner name="history-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </table>
}
